function setupNavItemEvents() {
    document.querySelectorAll('.nav-item').forEach(navItem => {
        // Clear existing event listeners by cloning the element
        const newNavItem = navItem.cloneNode(true);
        navItem.parentNode.replaceChild(newNavItem, navItem);

        if (window.innerWidth > 990) {
            // Add mouseenter and mouseleave events for larger screens
            newNavItem.addEventListener('mouseenter', function() {
                document.querySelectorAll('.nav-item').forEach(item => item.classList.remove('active'));
                this.classList.add('active');
            });

            newNavItem.addEventListener('mouseleave', function() {
                document.querySelectorAll('.nav-item').forEach(item => item.classList.remove('active'));
            });
        } else {
            // Add click event for smaller screens
            newNavItem.addEventListener('click', function() {
                const isActive = this.classList.contains('active');
                document.querySelectorAll('.nav-item').forEach(item => item.classList.remove('active'));
                if (!isActive) {
                    this.classList.add('active');
                }

                document.getElementById('mobileNavGraphic').classList.toggle('active');
            });
        }
    });
}

// Run the setup initially
setupNavItemEvents();

// Re-setup events on window resize
window.addEventListener('resize', setupNavItemEvents);


// Add click event listener for '.filter_name'
document.querySelectorAll('.filter_name').forEach(filterName => {
    filterName.addEventListener('click', function(event) {
        event.stopPropagation(); // Prevent the document click event from firing
        const isActive = this.classList.contains('active');
        document.querySelectorAll('.filter_name').forEach(name => {
            name.classList.remove('active');
            name.parentElement.querySelector('.filter_item_wrapper').style.display = 'none';
        });

        if (!isActive) {
            this.classList.add('active');
            this.parentElement.querySelector('.filter_item_wrapper').style.display = 'flex';
        }
    });
});

// Add click event listener for the document
document.addEventListener('click', function(event) {
    // Check if the clicked element is a child of a '.filter_item_wrapper'
    const clickedChild = event.target.closest('.filter_item_wrapper > *');
    if (clickedChild) {
        const filterName = clickedChild.closest('.filter_item_wrapper').previousElementSibling;
        if (filterName) {
            // Update the text of the '.filter_name' element
            filterName.textContent = clickedChild.textContent.trim();
        }
    }

    // Remove 'active' class and hide all '.filter_item_wrapper'
    document.querySelectorAll('.filter_name').forEach(name => {
        name.classList.remove('active');
        name.parentElement.querySelector('.filter_item_wrapper').style.display = 'none';
    });
});


document.getElementById('mobile-nav-trigger').addEventListener('click', function(e) {
    e.preventDefault();
    document.getElementById('main-mobile-navigation').classList.toggle('active');
    this.classList.toggle('active');
    //Stop the body from scrolling
    document.body.classList.toggle('no-scroll');
})

const mobileCloseIcons = document.querySelectorAll('.mobile-nav-close');

mobileCloseIcons.forEach(icon => { icon.addEventListener('click', function(e) {
    e.preventDefault();
    document.getElementById('main-mobile-navigation').classList.remove('active');
    //Allow the body to scroll

    document.body.classList.remove('no-scroll');
}) });


function Marquee(selector, speed) {
  const parentSelector = document.querySelectorAll(selector);
  parentSelector.forEach((userItem) => {
  const clone = userItem.innerHTML;
  const firstElement = userItem.children[0];
  let i = 0;
  userItem.insertAdjacentHTML('beforeend', clone);
  userItem.insertAdjacentHTML('beforeend', clone);

  setInterval(function () {
    firstElement.style.marginLeft = `-${i}px`;
    if (i > firstElement.clientWidth) {
      i = 0;
    }
    i = i + speed;
  }, 0);
  });
}

//after window is completed load
//1 class selector for marquee
//2 marquee speed 0.2
window.addEventListener('load', Marquee('.marquee', 0.2))
